export const CSV_TEMPLATE = `firstName,lastName,email,phone,startDate,status,tags,notes,assignedCoach
John,Doe,john.doe@example.com,555-123-4567,2026-07-01,active,"new agent, team-a",Great potential!,Cameron Wilson
Jane,Smith,jane.smith@example.com,555-987-6543,2026-07-01,pre-license,experienced,,Cameron Wilson`;

export const REQUIRED_FIELDS = [
  'firstName',
  'lastName',
  'email',
  'phone',
  'startDate',
  'status',
];

export const VALID_STATUSES = [
  'pre-license',
  'onboard',
  'active',
  'inactive',
  'at-risk',
  'graduated',
  'referral-brokerage',
  'moved-brokerages',
  'removed-from-program',
];
